(function ($, Global) {
    var LISTE_TYPE_BLOCS = {
        1: makeMultiSelectComponent,
        2: makeSelect2LevelsComponent,
        4: makeProposalComponent
    };
    var timeout;
    var showNbStep = true;
    var oldLastChildId = null;

    var SimulatorPage = function (parent) {
        this.appSimulator = new Global.Component({
            parent: document.getElementById(parent),
            actions: {
                init: function (state) {
                    var self = this;
                    runLoading($(self.parent))
                    $.ajaxGet('/ajax/subscriptionsv2/init')
                        .done(function (result) {
                            Global.ajaxCallback({
                                results: result,
                                success: function () {
                                    state.set('steps', [result.data]);

                                    if (result.data.listeReponses.length === 1) {
                                        showNbStep = false;
                                        self.store.dispatch('next', [result.data.listeReponses[0].idReponse]);
                                    } else {
                                        stopLoading($(self.parent));
                                    }
                                }
                            });
                        });
                },
                next: function (state, payload) {
                    var self = this;
                    var data = {
                        IdReponseSimulateur: payload,
                        CodePromo: "",
                        Devise: "EUR"
                    };
                    runLoading($(self.parent))
                    $.ajaxPost('/ajax/subscriptionsv2/next', data)
                        .done(function (result) {
                            Global.ajaxCallback({
                                results: result,
                                success: function () {
                                    var stateSteps = state.get('steps');
                                    stateSteps.push(result.data);

                                    state.set({
                                        selected: payload,
                                        steps: stateSteps,
                                        newStep: result.data
                                    });
                                    handleSimulatorComplete(result.data.simulateurTermine);
                                    stopLoading($(self.parent));
                                }
                            });
                        });
                },
                nextindependant: function (state, payload) {
                    var self = this;
                    var data = {
                        IdReponseSimulateur: payload,
                        CodePromo: "",
                        Devise: "EUR",
                        IsIndependant: true
                    };
                    runLoading($(self.parent))
                    $.ajaxPost('/ajax/subscriptionsv2/next', data)
                        .done(function (result) {
                            Global.ajaxCallback({
                                results: result,
                                success: function () {
                                    Global.location.href = '/order/Quote/indiv12-all';
                                }
                            });
                        });
                }
            },
            created: function () {
                this.store.dispatch('init');
            },
            updated: function (state) {
                var step = state.newStep || state.steps[0];
                var nStep = step.typeBloc === 3 ? (step.numeroEtape - 1) : step.numeroEtape;  
                var childIndex = _.findIndex(this.children, function (child) { return child.props.numeroEtape === nStep });
                var childComponent = LISTE_TYPE_BLOCS[step.typeBloc];

                if (childIndex >= 0 && step.typeBloc !== 3) {
                    this.children = this.children.slice(0, childIndex)
                }
                if (step.typeBloc === 3) {
                    var reponseIndex = _.findIndex(this.children[childIndex].props.listeReponses, function (reponse) {
                        return reponse.idReponse === state.selected[0]
                    });
                    if (reponseIndex < 0) return

                    this.children[childIndex].store.dispatch('inSecondLevel', { options: step.listeReponses })
                    this.children = this.children.slice(0, childIndex + 1)
                }

                if (!childComponent) return;

                this.children.push(childComponent($.extend({}, step, { parentId: this.id, showNbStep: showNbStep })));
            },
            mounted: function () {
                var self = this;
                var lastChild = self.children[self.children.length - 1];
                var heightNav = $('.nav-fixed-abo').outerHeight();

                if (!lastChild || this.children.length === 1 || (this.children.length === 2 && !showNbStep) || (lastChild.id === oldLastChildId)) return;

                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: $(lastChild.element).offset().top - heightNav - 50
                    }, 'slow');
                    oldLastChildId = lastChild.id;
                }, 300);
            }
        });
        this.appSimulator.render();
    };

    function makeMultiSelectComponent(props) {
        return new Component({
            template: document.getElementById('multiSelect'),
            props: props,
            state: { selected: {} },
            actions: {
                toggleAll: function (state, payload) {
                    var oldSelected = state.get('selected');
                    var newSelected = {};

                    newSelected[payload] = !oldSelected[payload];

                    state.set({
                        selected: newSelected,
                        listSelected: Object.keys(newSelected).filter(function (k) {
                            return !!newSelected[k]
                        })
                    })
                },
                toggleSelect: function (state, payload) {
                    var oldSelected = state.get('selected');
                    var newSelected = oldSelected;

                    delete newSelected[payload.first];

                    newSelected[payload.select] = !oldSelected[payload.select];

                    state.set({
                        selected: newSelected,
                        listSelected: Object.keys(newSelected).filter(function (k) {
                            return !!newSelected[k]
                        })
                    });
                }
            }
        });
    }

    function makeSelect2LevelsComponent(props) {
        return new Component({
            template: document.getElementById('select2Levels'),
            props: props,
            state: { selected: {} },
            actions: {
                selectSection: function (state, payload) {
                    var oldState = state.getAll();
                    var newState = {};
                    var newSelected = {};
                    
                    if (!payload.isSecondLevel) {
                        newSelected[payload.select] = !oldState.selected[payload.select];
                        newState = {
                            selected: newSelected
                        };
                    } else {
                        newSelected[payload.select] = true;
                        newState = {
                            selected: oldState.selected,
                            optionSelected: payload.select,
                            options: oldState.options
                        };
                    }
                    
                    var listSelected = Object.keys(newSelected).filter(function (k) {
                        return !!newSelected[k]
                    }).map(function (k) {
                        return parseInt(k, 10)
                    });

                    state.set(newState);

                    if (listSelected.length === 0) return;

                    $.Topic(payload.parentId).publish('next', listSelected);
                },
                closeSection: function (state, payload) {
                    state.set({
                        selected: {}
                    });
                },
                inSecondLevel: function(state, payload) {
                    var oldState = state.getAll();
                    state.set($.extend({}, oldState, { options: payload.options }));
                }
            }
        });
    }

    function makeProposalComponent(props) {
        return new Component({
            template: document.getElementById('proposal'),
            props: props,
            state: { selected: {}, code: '' },
            actions: {
                toggleSelect: function (state, payload) {
                    var self = this;
                    var newSelected = {};

                    newSelected[payload.select] = true

                    var data = {
                        IdReponseSimulateur: [payload.select],
                        CodePromo:  state.get('code') || "",
                        Devise: state.get('price') ? state.get('price').currency : 'EUR'
                    };
                    runLoading($(self.element))
                    $.ajaxPost('/ajax/subscriptionsv2/next', data)
                        .done(function (result) {
                            Global.ajaxCallback({
                                results: result,
                                success: function () {
                                    handleSimulatorComplete(result.data.simulateurTermine);
                                    if (!result.data.prixSimulateurAbo) return;
                                    var price = {
                                        LibelleAbonnement: result.data.prixSimulateurAbo.libelleAbonnement,
                                        LibelleAbonnementDescription: result.data.prixSimulateurAbo.libelleAbonnementDescription,
                                        subscriptionPossible: result.data.abonnementEnLignePossible,
                                        pasAssezLecteur: result.data.pasAssezDeLecteur,
                                        Langue: result.data.prixSimulateurAbo.Langue
                                    };
                                    var oldCurrency = state.get('price') ? state.get('price').currency : 'EUR';

                                    if (result.data.abonnementEnLignePossible) {
                                        $.extend(price, formatReponsePrice(result.data.prixSimulateurAbo));
                                    }

                                    state.set({
                                        selected: newSelected,
                                        code: state.get('code'),
                                        price: price
                                    });

                                    if (oldCurrency !== price.currency) {
                                        self.events.publish('getPrice', {
                                            code: state.get('code'),
                                            devise: oldCurrency
                                        });
                                    } else {
                                        stopLoading($(self.element));
                                    }
                                }
                            });
                        });
                },
                getLinkSubscription: function () {
                    var self = this;

                    runLoading($(self.element))
                    $.ajaxGet('/ajax/subscriptionsv2/onlinesubscription')
                        .done(function (result) {
                            Global.ajaxCallback({
                                results: result,
                                success: function () {
                                    handleButtonPayment(result.data);
                                    
                                    $('.modal-abonnement-nextstep').modal('show');
                                    stopLoading($(self.element));
                                }
                            });
                        });
                },
                getPrice: function (state, payload) {
                    var self = this
                    var data = {
                        CodePromo: payload.code || "",
                        Devise: payload.devise || "EUR"
                    };
                    runLoading($(self.element))
                    $.ajaxPost('/ajax/subscriptionsv2/price', data)
                        .done(function (result) {
                            Global.ajaxCallback({
                                results: result,
                                success: function () {
                                    var oldSubscriptionPossible = state.get('price') ? state.get('price').subscriptionPossible : false;
                                    var oldPasAssezLecteur = state.get('price') ? state.get('price').pasAssezLecteur : false;
                                    var price = {
                                        LibelleAbonnement: result.data.libelleAbonnement,
                                        LibelleAbonnementDescription: result.data.libelleAbonnementDescription,
                                        subscriptionPossible: oldSubscriptionPossible,
                                        pasAssezLecteur: oldPasAssezLecteur
                                    };

                                    $.extend(price, formatReponsePrice(result.data));

                                    state.set({
                                        selected: state.get('selected'),
                                        code: payload.code,
                                        price: price
                                    });

                                    stopLoading($(self.element));
                                }
                            });
                        })
                },
                submitCodePromo: function (state, payload) {
                    var code = $('#inputCodePromo').val();
                    this.store.dispatch('getPrice', { code: code, devise: state.get('price').currency });
                }
            },
            created: function () {
                this.store.dispatch('toggleSelect', { select: this.props.listeReponses[0].idReponse });
            }
        });
    }

    function formatPrice(currency, price, langue) {
        var locale = langue == 'francais' ? "fr-FR" : "en-IN";
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, currencyDisplay:'narrowSymbol' }).format(price);
    }

    function formatReponsePrice(reponse) {
        var currency = reponse.devise;
        var tarif = reponse.tarif;
        var langue = reponse.langue =='0'?'francais':'anglais';
        var tarifAvantReduc = reponse.tarifAvantReduc;
        var reduc = reponse.reductionPourcentage;
        var tarifUser = reponse.tarifParUtilisateur;
        var tarifUserAvantReduc = reponse.tarifParUtilisateurAvantReduc;

        return {
            currency: currency,
            displayTarif: formatPrice(currency, tarif, langue),
            displayTarifAvantReduc: formatPrice(currency, tarifAvantReduc, langue),
            displayDiffTarif: reduc && reduc > 0 ? formatPrice(currency, (tarif - tarifAvantReduc), langue) : null,
            displayTarifUser: formatPrice(currency, tarifUser, langue),
            displayTarifUserAvantReduc: formatPrice(currency, tarifUserAvantReduc, langue),
            displayReduc: reduc && reduc > 0 ? "-" + reduc + "%" : null,
            ReductionLibelle: reponse.reductionLibelle
        }
    }

    function runLoading($container) {
        $container.addClass('loading');
    }

    function stopLoading($container) {
        $container.removeClass('loading');
    }

    function handleSimulatorComplete(isComplete) {
        $('.bloc-helper')[isComplete ? 'addClass' : 'removeClass']('hidden');
    }

    function handleButtonPayment(lienRedirect) {
        if ($('.modal-abonnement-nextstep .payment-link-direct').exists()) {
            $('.modal-abonnement-nextstep .payment-link-direct').attr('href', lienRedirect)
        } else {
            $('.modal-abonnement-nextstep .payment-link').on('click', function () {
                $.Topic('signup-modal-show').publish('subscription', {
                    redirect: lienRedirect
                });
            });
        }
    }

	Global.SimulatorPage = SimulatorPage;
}(jQuery, window));